import styled from "styled-components";
import {Button, Row} from "antd";

export const ButtonsRow = styled(Row)`
    gap: 8px;
    @media (min-width: 1200px) {
        justify-content: flex-end;
    }
    @media (max-width: 1200px) and (min-width: 768px) {
        margin-bottom: 20px;
    }
`;
export const WaitingApproveButton = styled(Button)`
    color: "red";
    &:hover,
    &:active,
    &:focus {
        border-color: red;
    }
`;
